import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useI18n } from '@/context/I18nContext';
import { useRouter } from '@/context/RouterContext';
import { Mail, Bug, Shield, FileText } from 'lucide-react';
import { BugReportDialog } from './BugReportDialog';

export const Footer: React.FC = () => {
  const { user } = useAuth();
  const { t } = useI18n();
  const { navigate } = useRouter();
  const [isBugReportOpen, setIsBugReportOpen] = useState(false);

  return (
    <>
      <footer className="mt-auto py-8 px-4 border-t border-border-subtle flex items-center justify-center text-text-muted text-sm">
        <div className="flex items-start justify-center gap-8 sm:gap-12">
          <div className="flex flex-col items-start gap-2">
            <a
              href="mailto:info@yanicksenn.com"
              className="flex items-center gap-2 hover:text-text-primary transition-colors"
            >
              <Mail size={16} className="w-4 h-4 shrink-0" />
              <span>info@yanicksenn.com</span>
            </a>
            {user && (
              <button
                type="button"
                onClick={() => setIsBugReportOpen(true)}
                data-testid="footer-report-bug-link"
                className="flex items-center gap-2 hover:text-text-primary transition-colors cursor-pointer text-left"
              >
                <Bug size={16} className="w-4 h-4 shrink-0" />
                <span>{t('footer.reportBug')}</span>
              </button>
            )}
          </div>
          <div className="flex flex-col items-start gap-2">
            <a
              href="#/privacy"
              onClick={(e) => {
                e.preventDefault();
                navigate('#/privacy');
              }}
              className="flex items-center gap-2 hover:text-text-primary transition-colors"
            >
              <Shield size={16} className="w-4 h-4 shrink-0" />
              <span>{t('footer.privacyPolicy')}</span>
            </a>
            <a
              href="#/terms"
              onClick={(e) => {
                e.preventDefault();
                navigate('#/terms');
              }}
              data-testid="footer-terms-link"
              className="flex items-center gap-2 hover:text-text-primary transition-colors"
            >
              <FileText size={16} className="w-4 h-4 shrink-0" />
              <span>{t('footer.termsAndConditions')}</span>
            </a>
          </div>
        </div>
      </footer>
      {user && (
        <BugReportDialog
          open={isBugReportOpen}
          onClose={() => setIsBugReportOpen(false)}
        />
      )}
    </>
  );
};
